module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_rectangular_marco_comida_23.ef7bf6a1.png";